class SafeLoadScripts extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (!window.wetheme.__safeLoadInjectedSrcs) {
      window.wetheme.__safeLoadInjectedSrcs = new Set();
    }

    const placeholders = this.querySelectorAll(':scope > script');

    placeholders.forEach((script) => {
      const key = script.dataset.flowLoadKey || script.dataset.envyLoadKey;
      if (!script.getAttribute('src')) return;

      const absSrc = script.src;
      if (window.wetheme.__safeLoadInjectedSrcs.has(absSrc)) return;
      if (key && window.wetheme.webcomponentRegistry.checkScriptLoaded(key)) return;

      window.wetheme.__safeLoadInjectedSrcs.add(absSrc);

      const postLoadedScript = document.createElement('script');
      const { src, defer, async, type } = script;
      postLoadedScript.src = src;
      postLoadedScript.defer = defer;
      postLoadedScript.async = async;
      postLoadedScript.type = type;

      this.appendChild(postLoadedScript);
    });
  }
}
  
customElements.define('safe-load-scripts', SafeLoadScripts);